import { createApp } from "vue";
import App from "./app.vue";

createApp(App).mount("#main");